import {createContext} from 'react';
import {baseExperiments, baseFlags} from 'src/internal/defaults';

import type {InnerExperiments, InnerFlags} from 'src/types';

type XContext = {
  experiments: InnerExperiments;
  flags: InnerFlags;
};

export default createContext<XContext>({
  experiments: baseExperiments,
  flags: baseFlags,
});
